import React, { Component } from 'react';
import { Link } from 'gatsby';

class Paginate extends Component {
    render() {
        const { count, limit, skip } = this.props;
        const page = Math.ceil(skip / limit)
        let prevPage =  page > 1 ? `/news/${page}` : '/news';
        let nextPage =  `/news/${count}`
        if(page+1 < count) {
            nextPage = `/news/${page+2}`;
        }
        return (
            <div className="col-12 my-5 py-5 text-center">
            { page+1 !== 1  && (
                <Link to={prevPage} className="btn-paginate mx-5">&lt;</Link>
            )}
            { page+1 < count && (
                <Link to={nextPage} className="btn-paginate mx-5">&gt;</Link>
            )}                
            </div>
        )
    }
}

export default Paginate;